import { Action } from '@ngrx/store';

export enum ActionTypes {
  Add = '[id] Add to cart',
  Remove = '[id] Remove from cart',
  LoadItems = '[ids] Load items from server',
  LoadSuccess = '[ids] Load success'
}

export class AddToCart implements Action {
  readonly type = ActionTypes.Add;

  constructor(public payload: string) {}
}

export class GetItems implements Action {
  readonly type = ActionTypes.LoadItems;
}

export class RemoveFromCart implements Action {
  readonly type = ActionTypes.Remove;

  constructor(public payload: string) {}
}

export class LoadItems implements Action {
  readonly type = ActionTypes.LoadSuccess;

  constructor(public payload: string[]) {}
}

export type ActionsUnion = AddToCart | RemoveFromCart | LoadItems | GetItems;